//
//
//
//
//
//
//
//
//
//

import logoBlack from '../../svg/logoBlack.vue'
import logoBlue from '../../svg/logoBlue.vue'
import logoWhite from '../../svg/logoWhite.vue'
import logoBlueMobile from '../../svg/logoBlueMobile.vue'
import logoWhiteMobile from '../../svg/logoWhiteMobile.vue'
import { setCookie } from '../../../tools/cookie'
export default {
	name: 'logo',
	components: {
		logoBlue,
		logoBlack,
		logoWhite,
		logoBlueMobile,
		logoWhiteMobile,
	},
	inject: ['beforeToHome'],
	props: {
		homeUrl: {
			type: String,
		},
	},
	methods: {
		handle() {
			if (this.beforeToHome) {
				this.beforeToHome()
			}
			if (process.client) {
				location.href = this.homeUrl || location.origin
				setCookie('from', 'master')
			}
		},
	},
}
